// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__2r4iZ","colMin":"styles_colMin__1Qt8c","colCheckbox":"styles_colCheckbox__6YNtM"};